// CSS Modules - component class name prefix: SalesContainer__

<template>
  <div :class="$style.container">
    <div :class="$style.upper">
      <div :class="$style.upperInner">
        <div v-if="config.title" :class="$style.textContainer">
          <i :class="config.icon"></i>
          <span
            v-if="config.shop"
            :class="$style.titleShop"
            v-html="config.title"
          />
          <span v-else :class="$style.title" v-html="config.title" />
        </div>
        <div v-if="config.text" :class="$style.text">{{ config.text }}</div>
        <form
          v-if="
            config.input || config.dropdown || config.worldwide || config.jobs
          "
          @submit.prevent="handleSubmit"
          method="GET"
        >
          <div :class="$style.inputContainer">
            <template v-if="config.input">
              <input
                :class="$style.inputField"
                type="text"
                v-model="inputField"
                :placeholder="config.input.placeholderText"
                aria-label="postalcode"
              />
              <div @click="handleSubmit" :class="$style.button">
                <input
                  type="submit"
                  title="Suchen"
                  value=""
                  :class="$style.submitButton"
                  aria-label="submit postalcode"
                />
                <i class="fas fa-search"></i>
              </div>
            </template>
            <Select
              v-else-if="config.dropdown"
              colour="white"
              :selectOptions="config.dropdown.dropdownValues"
              selectValue=""
              trackBy="name"
              label="name"
              :placeholder="config.dropdown.dropdownPlaceholder"
              style="width: 100%; max-width: 25rem;"
              @onChange="handleSelectSubmit"
            />
            <Select
              v-else-if="config.jobs"
              colour="white"
              :selectOptions="regionSelectOptions"
              selectValue=""
              :placeholder="config.jobs.dropdownPlaceholder"
              style="width: 100%; max-width: 25rem;"
              @onChange="handleRegionSelect"
            />
            <Select
              v-if="config.jobs"
              :key="`jobCompanySelectKey-${dropdownOneValue}`"
              :class="$style.secondSelect"
              colour="white"
              :selectOptions="companySelectOptions"
              selectValue=""
              :placeholder="config.jobs.dropdownPlaceholderB"
              style="width: 100%; max-width: 25rem;"
              :style="{ visibility: showDropdownTwo ? 'visible' : 'hidden' }"
              @onChange="handleCountrySelect"
            />
            <Select
              v-else-if="config.worldwide"
              colour="white"
              :selectOptions="regionSelectOptions"
              selectValue=""
              :placeholder="config.worldwide.dropdownPlaceholder"
              style="width: 100%; max-width: 25rem;"
              @onChange="handleRegionSelect"
            />
            <Select
              v-if="config.worldwide && showDropdownTwo"
              :key="`worldwideCountrySelectKey-${dropdownOneValue}`"
              :class="$style.secondSelect"
              colour="white"
              :selectOptions="countrySelectOptions"
              selectValue=""
              :placeholder="config.worldwide.dropdownPlaceholder"
              style="width: 100%; max-width: 25rem;"
              @onChange="handleCountrySelect"
            />
          </div>
        </form>
        <template v-if="config.static">
          <p :class="$style.staticText">{{ config.static.phone }}</p>
          <p :class="$style.text">
            <a :href="mailtoLink">{{ config.static.email }}</a>
          </p>
        </template>
        <template v-if="config.shop">
          <p :class="$style.staticText">{{ config.shop.phone }}</p>
          <div :class="$style.text" v-html="config.shop.opening" />
        </template>
      </div>
    </div>
    <div v-if="config.buttons" :class="$style.lower">
      <template v-for="(button, index) in config.buttons">
        <a
          v-if="button.linkUrl"
          :class="$style.link"
          :href="button.linkUrl"
          :key="index"
        >
          <div :class="$style.imageContainer">
            <i :class="button.icon" />
          </div>
          <div :class="$style.linkText" v-html="button.text" />
        </a>
        <div v-else @click="startChat" :class="$style.link" :key="index">
          <div :class="$style.imageContainer">
            <i :class="button.icon" />
          </div>
          <div
            :class="$style.linkText"
            v-html="isChatActive ? button.text : button.offlineText"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Select from "../Select/Select";
import { regionDataUrl } from "../../shared/globals";

export default {
  name: "SalesContainer",
  components: {
    Select
  },
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      apiData: null,
      inputField: "",
      dropdownOneValue: "",
      showDropdownTwo: false,
      regionSelectOptions: [],
      countrySelectOptions: [],
      companySelectOptions: [],
      isChatActive: false,
      wtTrack: window.wtTrack
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.wtTrack({ cat: "SALESBOXCLICK" }, { inputIdent: this.inputField });
      window.location = `${this.config.input.submitUrl}${this.inputField}`;
    },
    handleSelectSubmit(value) {
      if (value.submitUrl) {
        this.wtTrack({ cat: "SALESBOXCLICK" }, { inputIdent: value.name });
        window.location = value.submitUrl;
      }
    },
    handleRegionSelect(value) {
      if (value !== "") {
        this.companySelectOptions = [];
        this.countrySelectOptions = [];
        this.dropdownOneValue = value;
        this.showDropdownTwo = true;

        if (this.config.jobs) {
          const targetgroups = [];
          for (let region of this.apiData.items) {
            if (
              region.filterCategories.country === this.dropdownOneValue ||
              value === this.config.resetSelectOption
            ) {
              for (let targetgroup of region.filterCategories.targetgroup) {
                targetgroups.push(targetgroup);
              }
            }
          }
          this.companySelectOptions.push(this.config.resetSelectOption);
          this.companySelectOptions.push(
            ...this.filterUniqueObjects(targetgroups)
          );
        } else if (this.apiData.regions) {
          for (let region of this.apiData.regions) {
            if (region.name === this.dropdownOneValue) {
              for (let country of region.countries) {
                this.countrySelectOptions.push(country.name);
              }
            }
          }
        }
      }
    },
    handleCountrySelect(value) {
      this.wtTrack(
        { cat: "SALESBOXCLICK" },
        { inputIdent: `${this.dropdownOneValue} - ${value}` }
      );

      if (this.config.worldwide) {
        window.location = `${this.config.worldwide.submitUrl}&cnEntry=${
          this.dropdownOneValue
        }&country=${value}`;
      }
      if (this.config.jobs) {
        if (this.config.resetSelectOption === value) value = "";
        if (this.config.resetSelectOption === this.dropdownOneValue)
          this.dropdownOneValue = "";

        window.location = `${
          this.config.jobs.submitUrl
        }?targetgroup=${value}&country=${this.dropdownOneValue}`;
      }
    },
    startChat() {
      if (
        window.LC_API &&
        window.LC_API.is_loaded() &&
        window.LC_API.open_chat_window
      ) {
        window.LC_API.open_chat_window();
        this.wtTrack({ cat: "LIVECHATBUTTONCLICK" });
        return false;
      }
	  if (
        window.Microsoft &&
        window.Microsoft.Omnichannel &&
		window.Microsoft.Omnichannel.LiveChatWidget &&
		window.Microsoft.Omnichannel.LiveChatWidget.SDK &&
		window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat
      ) {
		//if (this.config.d365FormUrl && !this.isChatActive)
		//{
			//window.location = this.config.d365FormUrl;
			//return false;
		//}
		//else
		//{
			window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
			this.wtTrack({ cat: "LIVECHATBUTTONCLICK" });
		//}
        return false;
      }
    },
    filterUniqueObjects(data) {
      return data.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    },
    initApiData(data) {
      if (this.config.jobs) {
        this.apiData = data;
        this.regionSelectOptions.push(
          this.config.resetSelectOption,
          ...this.filterUniqueObjects(
            this.apiData.items.map(region => region.filterCategories.country)
          )
        );
      } else if (data.regions) {
        this.apiData = data;
        this.regionSelectOptions.push(
          ...this.apiData.regions.map(region => region.name)
        );
      }
    },
    checkLCAgentsAvailability() {
      if (window.LC_API && window.LC_API.agents_are_available) {
        this.isChatActive = window.LC_API.agents_are_available();
        window.removeEventListener(
          "livechatReady",
          this.checkLCAgentsAvailability
        );
      } else {
        window.addEventListener(
          "livechatReady",
          this.checkLCAgentsAvailability
        );
      }
    },
	checkD365AgentsAvailability() {
      if (window.Microsoft && window.Microsoft.Omnichannel && Microsoft.Omnichannel.LiveChatWidget &&
			Microsoft.Omnichannel.LiveChatWidget.SDK && Microsoft.Omnichannel.LiveChatWidget.SDK.getAgentAvailability) {
        this.isChatActive = window.Microsoft.Omnichannel.LiveChatWidget.SDK.getAgentAvailability();
        window.removeEventListener(
          "liveD365chatReady",
          this.checkD365AgentsAvailability
        );
      } else {
        window.addEventListener(
          "liveD365chatReady",
          this.checkD365AgentsAvailability
        );
      }
    }
  },
  computed: {
    mailtoLink: function() {
      if (this.config.static) {
        return `mailto:${this.config.static.email}`;
      }
      return "";
    }
  },
  mounted() {
    let dataUrl = "";
    if (this.config.worldwide) {
      window.regionDataUrl
        ? (dataUrl = window.regionDataUrl)
        : (dataUrl = regionDataUrl);
    } else if (this.config.jobs) {
      dataUrl = this.config.jobs.jsonUrl;
    }
    axios
      .get(dataUrl)
      .then(response => this.initApiData(response.data))
      .catch(error => console.error(error));

    this.checkLCAgentsAvailability();
	this.checkD365AgentsAvailability();
  }
};
</script>

<style module lang="scss">
@import "./SalesContainer.scss";
</style>
